import {
  makeSelectAuthApiConfig,
  makeSelectResourceLoadingState,
} from 'services/api/api.selectors';
import { RequestApiDataIfNecessaryPayload } from 'services/api/api.types';
import {
  postContractOtpCheck,
  postContractOtpGenerate,
  postOtpCheck,
  postOtpGenerate,
} from 'services/otp/otp.config';
import { AppState, ReduxSelector } from 'store/types';
import { v4 as uuidV4 } from 'uuid';
import {
  ContractOtpCheckProps,
  ContractOtpGenerateProps,
  OtpCheckProps,
  OtpGenerateProps,
} from './otp.types';

export const selectOtpReducer = (reduxState: AppState) => reduxState.otp;

export const selectHasErrorOtp: ReduxSelector<boolean> = (
  reduxState: AppState,
) => selectOtpReducer(reduxState).hasError;

export const selectOtpJwt = (reduxState: AppState) =>
  selectOtpReducer(reduxState).jwt;

export function makeSelectPostOtpGenerateApiConfig(
  requestPayload: OtpGenerateProps,
): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return function selectOtpGenerateApiConfig(
    reduxState: AppState,
  ): RequestApiDataIfNecessaryPayload {
    return {
      resourceId: postOtpGenerate,
      requestConfig: makeSelectAuthApiConfig({
        url: postOtpGenerate,
        method: 'POST',
        data: {
          requestId: uuidV4(),
          name: requestPayload.name,
          surname: requestPayload.surname,
          email: requestPayload.email,
          phoneNumber: requestPayload.phoneNumber,
          phonePrefix: requestPayload.phonePrefix,
        },
      })(reduxState),
    };
  };
}

export function makeSelectPostOtpCheckApiConfig(
  requestPayload: OtpCheckProps,
): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return function selectOtpCheckApiConfig(
    reduxState: AppState,
  ): RequestApiDataIfNecessaryPayload {
    return {
      resourceId: postOtpCheck,
      requestConfig: makeSelectAuthApiConfig({
        url: postOtpCheck,
        method: 'POST',
        data: {
          requestId: uuidV4(),
          email: requestPayload.email,
          phoneNumber: requestPayload.phoneNumber,
          phonePrefix: requestPayload.phonePrefix,
          otp: requestPayload.otp,
          isVerify: requestPayload.isVerify,
          jwt: requestPayload.jwt,
        },
      })(reduxState),
    };
  };
}

export const selectOtpGenerateLoadState =
  makeSelectResourceLoadingState(postOtpGenerate);

export const selectOtpErrors = (reduxState: AppState) => reduxState.otp;

export function makeSelectPostContractOtpGenerateApiConfig(
  requestPayload: ContractOtpGenerateProps,
): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return (reduxState: AppState): RequestApiDataIfNecessaryPayload => ({
    resourceId: postContractOtpGenerate,
    requestConfig: makeSelectAuthApiConfig({
      url: postContractOtpGenerate,
      method: 'POST',
      data: {
        requestId: uuidV4(),
        phoneNumber: requestPayload.phoneNumber,
        phonePrefix: requestPayload.phonePrefix,
      },
    })(reduxState),
  });
}

export function makeSelectPostContractOtpCheckApiConfig(
  requestPayload: ContractOtpCheckProps,
): ReduxSelector<RequestApiDataIfNecessaryPayload> {
  return (reduxState: AppState): RequestApiDataIfNecessaryPayload => ({
    resourceId: postContractOtpCheck,
    requestConfig: makeSelectAuthApiConfig({
      url: postContractOtpCheck,
      method: 'POST',
      data: {
        requestId: uuidV4(),
        phoneNumber: requestPayload.phoneNumber,
        phonePrefix: requestPayload.phonePrefix,
        otp: requestPayload.otp,
      },
    })(reduxState),
  });
}
